import React from "react";
import { Route } from "react-router";

import { LoadError } from "@/mk2/components/errors/LoadError";
import { NotFoundError } from "@/mk2/components/errors/NotFoundError";

interface OwnProps {
    errorMessage: string;

    backButton?: React.ReactNode;

    onRetry?(): void;
}

export class Failure extends React.Component<OwnProps> {
    public render() {
        return (
            <Route
                render={({ staticContext }) => {
                    const { errorMessage, backButton, onRetry } = this.props;

                    // ak este nikto nenastavil http error status (napr. 403 - Forbidden z @authOnly,
                    // alebo 410 - Gone z render()) tak nastav podla hodnoty v errorMessage
                    if (errorMessage && errorMessage.toUpperCase() === "NOT FOUND" && backButton) {
                        if (staticContext && staticContext.statusCode === 200) {
                            staticContext.statusCode = 404;
                        }
                        return <NotFoundError button={backButton} />;
                    } else {
                        if (staticContext && staticContext.statusCode === 200) {
                            staticContext.statusCode = 500;
                        }
                        return <LoadError onRetry={onRetry} />;
                    }
                }}
            />
        );
    }
}
